// Must stay the first import: it captures the SSO token before @reach/router snapshots
// window.location. See the comment in that module.
import './modules/session/session-bootstrap';

import LuxonUtils from '@date-io/luxon';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { LocationProvider } from '@reach/router';
import axios from 'axios';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { ErrorBoundary } from 'react-error-boundary';

import App from './App';
import { AppErrorFallback, handleAppError } from './components/AppErrorFallback';
import { session } from './modules/session';
import { installSessionInterceptor } from './modules/session/axios-session-interceptor';
import reportWebVitals from './reportWebVitals';
import './setup/i18n';
import AuthenticationProvider from './stores/Authentication';

// The generated API client issues its requests through the global axios instance, so this has to be
// in place before anything can render and fire one.
installSessionInterceptor(axios, session);

ReactDOM.render(
  <StrictMode>
    <AuthenticationProvider>
      <MuiPickersUtilsProvider utils={LuxonUtils} locale="de">
        <LocationProvider>
          <ErrorBoundary FallbackComponent={AppErrorFallback} onError={handleAppError}>
            <App />
          </ErrorBoundary>
        </LocationProvider>
      </MuiPickersUtilsProvider>
    </AuthenticationProvider>
  </StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
